import type { FeedItemType } from '@/types';

export const getImageParams = (data: FeedItemType) => {
  const { channel_id, object_location, dimensions } = data;
  const params = {
    ...data,
    ...(channel_id && { channel_id }),
    link: object_location,
    dimension: dimensions || {},
  };

  return params;
};
